import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";
import { administrativeError } from "../administrativeError";

export async function getLegacyInvitationCount() {
    try {
        const response = await axios.get(`${FIRMFLOWURL}api/invitations/legacy-count`, {
            headers: { Authorization: Cookies.get("Bearer") }, suppressForbiddenToast: true, timeout: 30000,
        });
        return { success: true, count: response.data.count };
    } catch (error) {
        return administrativeError(error, "Unable to load outstanding legacy invitations.");
    }
}

// Eligibility is supplied by employee reads; POST revalidates it authoritatively.
export async function reissueInvitation(employeeId) {
    try {
        const response = await axios.post(
            `${FIRMFLOWURL}api/invitations/${encodeURIComponent(employeeId)}/reissue`, null,
            { headers: { Authorization: Cookies.get("Bearer") }, suppressForbiddenToast: true, timeout: 30000 },
        );
        return { success: response.data.success === true, emailSent: response.data.emailSent === true };
    } catch (error) {
        const result = administrativeError(error, "Unable to reissue the invitation. The account may be ineligible.");
        if (result.status === 400) result.message = "Account is not eligible for invitation reissue.";
        // Never propagate raw response data: it may contain invitation secrets.
        return { success: false, status: result.status, message: result.message };
    }
}
